"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagPaddingVerticalXSmall = exports.TagPaddingVerticalSmall = exports.TagPaddingVerticalMedium = exports.TagPaddingVerticalLarge = exports.TagPaddingHorizontalXSmall = exports.TagPaddingHorizontalSmall = exports.TagPaddingHorizontalMedium = exports.TagPaddingHorizontalLarge = exports.NavBarPaddingVerticalSmall = exports.NavBarPaddingVerticalMedium = exports.NavBarPaddingVerticalLarge = exports.NavBarPaddingHorizontalSmall = exports.NavBarPaddingHorizontalMedium = exports.NavBarPaddingHorizontalLarge = exports.ButtonGroupPaddingVerticalSmall = exports.ButtonGroupPaddingVerticalMedium = exports.ButtonGroupPaddingVerticalLarge = exports.ButtonGroupPaddingHorizontalSmall = exports.ButtonGroupPaddingHorizontalMedium = exports.ButtonGroupPaddingHorizontalLarge = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonGroupPaddingHorizontalLarge = 32;
exports.ButtonGroupPaddingHorizontalLarge = ButtonGroupPaddingHorizontalLarge;
var ButtonGroupPaddingHorizontalMedium = 24;
exports.ButtonGroupPaddingHorizontalMedium = ButtonGroupPaddingHorizontalMedium;
var ButtonGroupPaddingHorizontalSmall = 24;
exports.ButtonGroupPaddingHorizontalSmall = ButtonGroupPaddingHorizontalSmall;
var ButtonGroupPaddingVerticalLarge = 24;
exports.ButtonGroupPaddingVerticalLarge = ButtonGroupPaddingVerticalLarge;
var ButtonGroupPaddingVerticalMedium = 16;
exports.ButtonGroupPaddingVerticalMedium = ButtonGroupPaddingVerticalMedium;
var ButtonGroupPaddingVerticalSmall = 16;
exports.ButtonGroupPaddingVerticalSmall = ButtonGroupPaddingVerticalSmall;
var NavBarPaddingHorizontalLarge = 32;
exports.NavBarPaddingHorizontalLarge = NavBarPaddingHorizontalLarge;
var NavBarPaddingHorizontalMedium = 24;
exports.NavBarPaddingHorizontalMedium = NavBarPaddingHorizontalMedium;
var NavBarPaddingHorizontalSmall = 16;
exports.NavBarPaddingHorizontalSmall = NavBarPaddingHorizontalSmall;
var NavBarPaddingVerticalLarge = 24;
exports.NavBarPaddingVerticalLarge = NavBarPaddingVerticalLarge;
var NavBarPaddingVerticalMedium = 16;
exports.NavBarPaddingVerticalMedium = NavBarPaddingVerticalMedium;
var NavBarPaddingVerticalSmall = 16;
exports.NavBarPaddingVerticalSmall = NavBarPaddingVerticalSmall;
var TagPaddingHorizontalLarge = 12;
exports.TagPaddingHorizontalLarge = TagPaddingHorizontalLarge;
var TagPaddingHorizontalMedium = 10;
exports.TagPaddingHorizontalMedium = TagPaddingHorizontalMedium;
var TagPaddingHorizontalSmall = 8;
exports.TagPaddingHorizontalSmall = TagPaddingHorizontalSmall;
var TagPaddingHorizontalXSmall = 4;
exports.TagPaddingHorizontalXSmall = TagPaddingHorizontalXSmall;
var TagPaddingVerticalLarge = 6;
exports.TagPaddingVerticalLarge = TagPaddingVerticalLarge;
var TagPaddingVerticalMedium = 2;
exports.TagPaddingVerticalMedium = TagPaddingVerticalMedium;
var TagPaddingVerticalSmall = 1;
exports.TagPaddingVerticalSmall = TagPaddingVerticalSmall;
var TagPaddingVerticalXSmall = 3;
exports.TagPaddingVerticalXSmall = TagPaddingVerticalXSmall;